module.exports = __webpack_public_path__ + "img/no_stock.db737702.svg";